import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import Cookies from "universal-cookie";
import 'react-pro-sidebar/dist/css/styles.css';
import {Navbar,Nav,NavDropdown} from 'react-bootstrap';
import logoprofile from "./images/profile.png";
import logokn from "./images/logokn.png";
import ModalPWD from './passwordCHG';
import News from './News';
import Profile from './profile';
import B_form from './B_form';
import "./header/Header.css";
import {MenuItem} from 'react-pro-sidebar';
import config from '../config';
const cookies = new Cookies();
//const ref = React.createRef();
const axios = require("axios");
class HeaderTop extends Component {
    constructor(props)
    {
        super(props);
        this.state= {pwd:"",isvalid:false,CountNews:0};
        this.handlechg=this.handlechg.bind();
        this.handlesignout=this.handlesignout.bind();
        this.handlebform=this.handlebform.bind();
        this.handlenews=this.handlenews.bind();
        this.handler = this.handler.bind(this);
        this.handler2=this.handler2.bind(this);
        this.handerprofile=this.handlerprofile.bind(this);
    }
    handler2(){
        this.props.handler3();
    }
    handler(i,nid){
        config.Newsarraycount=config.Newsarray.length-1;
        //this.setState({config.CountNews:config.Newsarray.length-1});    
        
        axios({
            method:"post",
            url:cookies.get("phpclass")+"/index.php/user/UpdateNotifications/"+nid+"/"+cookies.get("LoginID"),
            Headers:{"content-type":"multipart/formdata"}
          })
          .then((response)=>{
            if(response.data===1)
            {
              config.Newsarray.splice(i,1);
    //          changeNewsState(config.Newsarray.length);
            }
          })
    }
    componentDidMount(){
        if(!cookies.get("LoginID"))
        { 
//            window.location.href="https://www.thekandnsway.pk/kandns/login/";
            window.location.href=config.Appdir+"/login/";
            //window.location.href="https://"+document.location.hostname+"/"+config.Appdir+"/login/";
        }
        else
        {
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/GetNotifications/'+cookies.get("LoginID"),
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                config.Newsarray = response.data;
                config.Newsarraycount = response.data.length;
                this.setState({isvalid:true,});
            })
        }
    }
    handlechg=()=>{
        this.setState({isvalid:true,pwd:<ModalPWD/>});
    }
    handlerprofile=()=>{
        this.setState({isvalid:true,pwd:<Profile handler2={this.handler2}/>}); //action={this.handler(i)}/>});
    }
    handlebform=()=>{
        this.setState({isvalid:true,pwd:<B_form handler2={this.handler2}/>});
    }
    handlenews=()=>{
        
        if(this.state.pwd === "" && config.Newsarray.length>0)
            this.setState({isvalid:true,pwd:<News handler={this.handler}/>}); //action={this.handler(i)}/>});
        else
            this.setState({isvalid:false,pwd:""})
    }   
    handlesignout=()=>{
        cookies.remove("LoginID");
        cookies.remove("EmpName");
        window.location.href=config.Appdir+"/login";
    }
    render(){
        let isvalid=this.state.isvalid;
        if(isvalid)
            {this.setState({isvalid:false});return(<div>{this.state.pwd}</div>);}
        else
        {
        return (
            <div className="main">
                <Navbar className="navbar navbar-static-top">
                    <Navbar.Brand href="#home"></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" float="right"/>
                    <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="mr-auto"><img src={logokn} alt="" style={{height:"30px",paddingTop:0}} ></img>
                    </Nav>
{/*}                    <Nav style={{marginRight:"2%",width:"110px"}}>
                        <NavDropdown  id="nav-dropdown" title="My admin"  style={{fontSize:12, fontFamily:"tahoma",paddingRight:"10px",backgroundColor:"gray",color:"white"}}>
                        <div style={{fontSize:12, fontFamily:"tahoma",padding:"0px",backgroundColor:"gray",color:"white"}}>                
                        <MenuItem style={{fontSize:12, fontFamily:"tahoma",padding:"0px",backgroundColor:"gray",color:"white"}}>
                            <NavLink to="./profile" className="nav-link" activeClassName="active" ><span style={{height:"10px"}}> My profile</span> </NavLink>
                        </MenuItem>
                        <MenuItem onClick={this.handlechg.bind()}  className="nav-link" activeClassName="active" ><span style={{cursor:"pointer",height:"10px"}}>Change Password</span> </MenuItem> 
                        <MenuItem onClick={this.handlesignout.bind()} className="nav-link" activeClassName="active"><span style={{cursor:"pointer"}}>Sign Out</span></MenuItem> 
                        </div>
                        </NavDropdown>
                    </Nav>
        */}         
                    <button  className="nbutton" onClick={this.handlenews.bind()}>
                        <p className="fa fa-bell-o" style={{fontSize:'15pt',color:'blue',paddingTop:'12px',backgroundColor:'transparent'}}>{config.Newsarraycount}</p>
                   </button>

                    <Nav>
                        <NavDropdown  id="nav-dropdown" title={<img className="rounded-circle z-depth-2" height="30px" width="30px" src={logoprofile} alt=""/>} >
                        <div style={{fontSize:12, fontFamily:"tahoma",paddingRight:"10px"}}>
                        <MenuItem>
                            <NavLink to="./profile" className="nav-link" activeClassName="active" ><span style={{height:"10px"}}> My profile</span> </NavLink>
                        </MenuItem>
                        <MenuItem>
                            <NavLink to="./B_form" className="nav-link" activeClassName="active" ><span style={{height:"10px"}}> B Form (upload)</span> </NavLink>
                        </MenuItem> 

                        <MenuItem onClick={this.handlechg.bind()}  className="nav-link" activeClassName="active" ><span style={{cursor:"pointer",height:"10px"}}>Change Password</span> </MenuItem> 
                        <MenuItem onClick={this.handlesignout.bind()} className="nav-link" activeClassName="active"><span style={{cursor:"pointer"}}>Sign Out</span></MenuItem> 
                        </div>
                        </NavDropdown>
                    </Nav>

                    </Navbar.Collapse>
                </Navbar>
                <div style={{marginTop:"10px",float:"right"}}>
                    {this.state.pwd}
                </div>
            </div>
        );
    }
    }
}
export default HeaderTop;
//export default withRouter(HeaderTop);